import { toast } from "@outpave/ds";

/**
 * The failure half of a mutation handler.
 *
 * Apollo rejects the mutate promise on a GraphQL or network error, so a
 * handler shaped `const result = await mutate(); if (result) {...} else {...}`
 * never reaches its else on a real failure: the rejection escapes instead,
 * nothing is reported, and the UI is left mid-action. Catch and pass the error
 * here so the same failure says the same thing everywhere.
 *
 * `fallback` arrives translated, because the message differs per caller.
 */
export const toastMutationError = (err: unknown, fallback: string): void => {
  console.error(err);
  const message = err instanceof Error ? err.message : "";
  toast.error(message || fallback);
};
